/* Fashion CITY — 커스텀 모자: 스타일 → 색상 → 사진
   ★ 스타일이나 색을 추가/삭제하거나 이름을 바꾸려면 이 파일만 고치면 됩니다.

   styles : 맨 윗줄에 나오는 모자 종류. 누르면 그 아래 색상 사진들이 바뀝니다.
     n      : 손님에게 보이는 이름
     sku    : 우리 스타일 번호 (주문서에 같이 남습니다)
     colors : [색 이름, 사진 주소]
     place  : (선택) 이 스타일만 자수 자리를 다르게 잡고 싶을 때
*/
var FC_CDN = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/files/';

window.FCPO_STYLES = {
  'custom-two-tone-trucker-hat-your-design': {
    styleLabel: 'Cap style',
    colorLabel: 'Cap color',
    styles: [
      {
        n: 'Classic Two-Tone', sku: '28-TCM0002',
        colors: [
          ['Black',      FC_CDN + '2-TCM0002-BLACK-01.jpg?v=1766008782'],
          ['Navy',       FC_CDN + '2-TCM0002-NAVY-01.jpg?v=1766008782'],
          ['Red',        FC_CDN + '2-TCM0002-RED-01.jpg?v=1766008782'],
          ['Green',      FC_CDN + '2-TCM0002-GREEN-01.jpg?v=1766008782'],
          ['Burgundy',   FC_CDN + '2-TCM0002-BURGUNDY-01.jpg?v=1766008782'],
          ['Beige',      FC_CDN + '2-TCM0002-BEIGE-01.jpg?v=1766008782'],
          ['Grey',       FC_CDN + '28-TCM0002-GRY.jpg?v=1766008782'],
          ['Royal Blue', FC_CDN + '28-TCM0002-BLU.jpg?v=1766008782'],
          ['Dark Denim', FC_CDN + '28-TCM0002-DDN.jpg?v=1766008782'],
          ['Lavender',   FC_CDN + '28-TCM0002-LVD.jpg?v=1766008782'],
          ['Chocolate',  FC_CDN + '28-TCM0002-CHL.jpg?v=1766008782'],
          ['Burnt Orange', FC_CDN + '28-TCM0002-BOR.jpg?v=1766008782'],
          ['Pink',       FC_CDN + 'd98dfba7ab3ccde133a55d48501a0758917430cb13515652eb6b197adb6acf4e.webp?v=1779808455']
        ]
      },
      {
        n: 'Color Two-Tone', sku: '28-TCM0002-TWOTONE',
        colors: [
          ['Burgundy / Dk Green', FC_CDN + '28-TCM0002-BURGUNDYDKGREEN.jpg?v=1762290436'],
          ['Black / Olive',       FC_CDN + '28-TCM0002-BLACKOLIVE.jpg?v=1762290436'],
          ['Blue / Red',          FC_CDN + '28-TCM0002-BLUERED.jpg?v=1762290436'],
          ['Brown / Navy',        FC_CDN + '28-TCM0002-BROWNNAVY.jpg?v=1762290436'],
          ['Dk Green / Blush',    FC_CDN + '28-TCM0002-TWOTONE-DKGREENBLUSHPINK.jpg?v=1762458880'],
          ['Navy / Dk Green',     FC_CDN + '28-TCM0002-NAVYDKGREEN.jpg?v=1762290436'],
          ['Red / Blue',          FC_CDN + '28-TCM0002-REDBLUE.jpg?v=1762290436'],
          ['Teal / Olive',        FC_CDN + '28-TCM0002-TYLOLV.jpg?v=1762290436']
        ]
      },
      {
        n: 'College Two-Tone', sku: '28-TCM0002-college',
        colors: [
          ['Cream / Black',     FC_CDN + '28-TCM0002-CREAMBLACK.jpg?v=1750350403'],
          ['Cream / Burgundy',  FC_CDN + '28-TCM0002-CREAMBURGUNDY.jpg?v=1750350403'],
          ['Cream / Navy',      FC_CDN + '28-TCM0002-CREAMNAVY.jpg?v=1750350394'],
          ['Cream / Orange',    FC_CDN + '28-TCM0002-CREAMORANGE.jpg?v=1750350394'],
          ['Cream / Purple',    FC_CDN + '28-TCM0002-CREAMPURPLE.jpg?v=1750350394'],
          ['Cream / Red',       FC_CDN + '28-TCM0002-CREAMRED.jpg?v=1750350394'],
          ['Cream / Royal',     FC_CDN + '28-TCM0002-CREAMROYALBLUE.jpg?v=1750350394'],
          ['Cream / Dk Green',  FC_CDN + '28-TCM0002-2.jpg?v=1755611052']
        ]
      },
      {
        n: 'Corduroy', sku: '28-TCM0003',
        colors: [
          ['Beige',          FC_CDN + '28-TCM003-BEIGE-01.jpg?v=1747155275'],
          ['Black',          FC_CDN + '28-TCM003-BLACK-01.jpg?v=1747155275'],
          ['Burgundy',       FC_CDN + '28-TCM003-BURGUNDY-01.jpg?v=1747155275'],
          ['Green',          FC_CDN + '28-TCM003-GREEN-01.jpg?v=1747155275'],
          ['Navy',           FC_CDN + '28-TCM003-NAVY-01.jpg?v=1747155275'],
          ['Burnt Orange',   FC_CDN + '28-TCM0003-BOR.jpg?v=1747155275'],
          ['Brown',          FC_CDN + '28-TCM0003-BRN.jpg?v=1747155275'],
          ['Rust',           FC_CDN + '28-TCM0003-RST.jpg?v=1747155275'],
          ['Sage',           FC_CDN + '28-TCM0003-SAGE.jpg?v=1747155275'],
          ['Red',            FC_CDN + '28-TCM0003-RED.jpg?v=1747748976'],
          ['Brown / Pink',   FC_CDN + '28-TCM0003-BRNPNK.jpg?v=1747155275'],
          ['Brown / Rust',   FC_CDN + '28-TCM0003-BRNRST-01.jpg?v=1747155275'],
          ['Cream / Black',  FC_CDN + '28-TCM0003-CRMBLK.jpg?v=1747155275'],
          ['Navy / Mint',    FC_CDN + '28-TCM0003-NVYMNT.jpg?v=1747155275'],
          ['Sage / Pink',    FC_CDN + '28-TCM0003-SGEPNK.jpg?v=1747155275'],
          ['Teal / Brown',   FC_CDN + '28-TCM0003-TELBRN.jpg?v=1747155275'],
          ['Beige / Denim',  FC_CDN + '28-TCM0003-LBGLDN.jpg?v=1754415205']
        ]
      },
      {
        n: 'Corduroy Rope', sku: '28-TCM1012',
        colors: [
          ['Brown', FC_CDN + '28-TCM1012-BRN.jpg?v=1778690611'],
          ['Black', FC_CDN + '28-TCM1012-BLK.jpg?v=1778690612'],
          ['Green', FC_CDN + '28-TCM1012-GRN.jpg?v=1778690611'],
          ['Navy',  FC_CDN + '28-TCM1012-NVY.jpg?v=1778690612'],
          ['Red',   FC_CDN + '28-TCM1012-RED.jpg?v=1778690612']
        ]
      },
      {
        n: 'Checkerboard Brim', sku: '28-TCM1020',
        colors: [
          ['Black',      FC_CDN + '28-TCM1020-BLACK.jpg?v=1773429747'],
          ['Navy',       FC_CDN + '28-TCM1020-NAVY.jpg?v=1773430040'],
          ['Burgundy',   FC_CDN + '28-TCM1020-BURGUNDY.jpg?v=1773429747'],
          ['Blue',       FC_CDN + '28-TCM1020-BLUE.jpg?v=1773429747'],
          ['Dark Green', FC_CDN + '28-TCM1020-DARKGREEN.jpg?v=1773430040'],
          ['Orange',     FC_CDN + '28-TCM1020-ORANGE-06.jpg?v=1773430040'],
          ['Purple',     FC_CDN + '28-TCM1020-PURPLE.jpg?v=1773430040']
        ]
      },
      {
        n: 'Polka Dot Brim', sku: '28-TCM1021',
        colors: [
          ['Black', FC_CDN + '28-TCM1021-BLK_c15984cb-eca3-45c7-af0d-17c8c7575142.jpg?v=1773157147'],
          ['Navy',  FC_CDN + '28-TCM1021-NVY_c472af63-a878-4479-aba7-08adc9561bde.jpg?v=1773157216'],
          ['Red',   FC_CDN + '28-TCM1021-RED_45e9fcf0-0def-4b6f-a432-0989ec71c6c1.jpg?v=1773157147'],
          ['White', FC_CDN + '28-TCM1021-WHT_55435835-955d-4da6-b720-3673ac1f0e46.jpg?v=1773157216'],
          ['Brown', FC_CDN + '28-TCM1021-BRN_efe40e84-9989-456b-948b-e626355520a7.jpg?v=1773157216']
        ]
      },
      {
        n: 'Color Pop Button', sku: '28-TCM0005',
        colors: [
          ['Black',      FC_CDN + '28-TCM0005-BLACK.jpg?v=1773432639'],
          ['Navy',       FC_CDN + '28-TCM0005-NVY.jpg?v=1773432707'],
          ['Red',        FC_CDN + '28-TCM0005-RED.jpg?v=1773432639'],
          ['Burgundy',   FC_CDN + '28-TCM0005-BGD.jpg?v=1773432639'],
          ['Royal Blue', FC_CDN + '28-TCM0005-ROYALBLUE.jpg?v=1773432639'],
          ['Dark Green', FC_CDN + '28-TCM0005-DGN.jpg?v=1773432639'],
          ['Green',      FC_CDN + '28-TCM0005-GRN.jpg?v=1773432639'],
          ['Purple',     FC_CDN + '28-TCM0005-PUP.jpg?v=1773432707'],
          ['Lt Pink',    FC_CDN + '28-TCM0005-LPK.jpg?v=1773432639'],
          ['Brown',      FC_CDN + '28-TCM0005-BRN.jpg?v=1775739298']
        ]
      },
      {
        n: 'Duck Camo Brim', sku: '28-TCM1028',
        colors: [
          ['Blue',  FC_CDN + '28-TCM1028-BLUE_9bb97052-f88f-405e-8df2-2ffd1aaacecd.jpg?v=1776107304'],
          ['Beige', FC_CDN + '28-TCM1028-BEIGE_53fd90e9-84f7-4555-af59-1e84e1d5d320.jpg?v=1776107304']
        ]
      },
      {
        n: 'Leopard', sku: '28-TCM1043 / 28-TCM0010LPD',
        colors: [
          ['Rose',   FC_CDN + '28-TCM1043-RSE.jpg?v=1786641039'],
          ['Beige',  FC_CDN + '28-TCM1043-BGE.jpg?v=1786641039'],
          ['Grey',   FC_CDN + '28-TCM1043-GRY.jpg?v=1786641039'],
          ['Canvas', FC_CDN + '28-TCM0010-LPD_d6357ef8-b953-4da9-9856-3cbc31ee4e70.jpg?v=1759325965']
        ]
      },
      {
        n: 'Zebra Brim', sku: '28-TCM0010ZBR',
        colors: [
          ['Zebra', FC_CDN + '28-TCM0010-ZEBRA.jpg?v=1783967967']
        ]
      }
    ]
  }
};

/* 자수 자리 (스타일에 place 가 따로 없으면 이 값을 씁니다)
     x, y : 문구 중심. y 가 클수록 아래(챕 쪽).
     w    : Medium(4") 일 때 가로 폭 (사진 가로폭의 %)
     h    : Medium 일 때 글자 높이 (사진 세로폭의 %) — 세로로 늘려 앞판을 채웁니다
     sizes: [Small, Medium, Large] 실제 가로 인치 */
window.FCPO_PLACE_BY_HANDLE = {
  'custom-two-tone-trucker-hat-your-design': [
    { v: 'Front panel', x: 50, y: 47, w: 48, h: 29, sizes: [3, 4, 4.8] }
  ]
};
